export function BytesToMegabytes(value: number): number {
  return value / 1_000_000;
}

export function KilobytesToMegabytes(value: number): number {
  return value / 1_024;
}
